import { ALL_CLIENT_OPTION } from "./PawLoad.constants";

export const parseClientCustomerFilters = (tempFilters) => {
  const filterSelectMap = {};
  const clientDetailsMap = {};

  Object.keys(tempFilters).forEach((colKey) => {
    if (colKey === "clientNameAbbreviation") {
      tempFilters[colKey].forEach((client) => {
        clientDetailsMap[client.value] = client;
      });
    }
    filterSelectMap[colKey] = tempFilters[colKey].map((row) => ({
      value: row.id,
      label: row.value,
    }));
  });

  return { filterSelectMap, clientDetailsMap };
};

export const getClientLabelsForCustomer = (filterSelectMap, customerLabel) => {
  const customerToClientsMap = filterSelectMap.customerClientMapping || [];
  const mapping = customerToClientsMap.find((m) => m.value === customerLabel);
  return mapping ? mapping.label : [];
};

export const getClientsForCustomer = (allClients, clientLabelsForCustomer) =>
  (allClients || []).filter((client) =>
    clientLabelsForCustomer.includes(client.label)
  );

export const getPopulationTypeOptions = (clientsForCustomer, clientDetailsMap) => {
  const uniquePopulationTypes = new Set();
  clientsForCustomer.forEach((clientOption) => {
    const clientDetail = clientDetailsMap[clientOption.label];
    if (clientDetail?.populationType) {
      uniquePopulationTypes.add(clientDetail.populationType);
    }
  });
  return Array.from(uniquePopulationTypes).map((populationType) => ({
    value: populationType,
    label: populationType,
  }));
};

export const getClientsForCustomerAndPopulation = (
  clientsForCustomer,
  clientDetailsMap,
  populationType
) =>
  clientsForCustomer.filter((clientOption) => {
    const clientDetail = clientDetailsMap[clientOption.label];
    return clientDetail?.populationType === populationType;
  });

export const buildClientOptionsForPopulation = (
  clientsForCustomer,
  clientDetailsMap,
  populationType
) => {
  const filteredClients = getClientsForCustomerAndPopulation(
    clientsForCustomer,
    clientDetailsMap,
    populationType
  );
  return [ALL_CLIENT_OPTION, ...filteredClients];
};

export const buildPawGroupPayload = (
  selectedCustomer,
  selectedPopulationType,
  selectedClient
) => {
  if (selectedClient.value === ALL_CLIENT_OPTION.value) {
    return {
      isCustomerPawGroup: true,
      customerInfoUuid: selectedCustomer.value,
      populationType: selectedPopulationType.value,
    };
  }

  return {
    isCustomerPawGroup: false,
    clientInfoUuid: selectedClient.value,
  };
};

export const buildPawLoadScopeLabel = (
  selectedCustomer,
  selectedPopulationType,
  selectedClient
) => {
  const populationLabel =
    selectedPopulationType.label.charAt(0).toUpperCase() +
    selectedPopulationType.label.slice(1).toLowerCase();

  return `${selectedCustomer.label} / ${populationLabel} / ${selectedClient.label}`;
};

export const getPawLoadErrorMessage = (
  error,
  selectedCustomer,
  selectedPopulationType,
  selectedClient
) => {
  const errorData = error?.data;
  let apiMessage = "";

  if (typeof errorData === "string" && errorData.trim()) {
    apiMessage = errorData;
  } else if (typeof errorData?.detail === "string" && errorData.detail.trim()) {
    apiMessage = errorData.detail;
  } else if (typeof errorData?.message === "string" && errorData.message.trim()) {
    apiMessage = errorData.message;
  } else if (typeof errorData?.errorCode === "string" && errorData.errorCode.trim()) {
    apiMessage = errorData.errorCode;
  } else if (typeof error?.message === "string" && error.message.trim()) {
    apiMessage = error.message;
  }

  if (
    apiMessage.toLowerCase().includes("already in progress") &&
    selectedCustomer &&
    selectedPopulationType &&
    selectedClient
  ) {
    return `PAW Load already queued for ${buildPawLoadScopeLabel(
      selectedCustomer,
      selectedPopulationType,
      selectedClient
    )}`;
  }

  return apiMessage || "Something went wrong. Please try again.";
};
